import React from 'react';

const SemanticSkeleton = ({ type = 'page' }) => {
  if (type === 'page') {
    return (
      <div className="min-h-screen bg-beige-light animate-pulse">
        {/* Header Skeleton */}
        <div className="h-20 bg-white border-b border-gray-100 flex items-center px-8">
          <div className="w-32 h-8 bg-gray-200 rounded"></div>
          <div className="ml-auto flex gap-6">
            <div className="w-20 h-4 bg-gray-200 rounded"></div>
            <div className="w-20 h-4 bg-gray-200 rounded"></div>
            <div className="w-20 h-4 bg-gray-200 rounded"></div>
          </div>
        </div>
        
        {/* Hero Skeleton */}
        <div className="h-[60vh] bg-gray-100 flex items-center justify-center">
          <div className="max-w-2xl w-full px-8 space-y-4">
            <div className="h-12 bg-gray-200 rounded w-3/4 mx-auto"></div>
            <div className="h-6 bg-gray-200 rounded w-1/2 mx-auto"></div>
          </div>
        </div>

        {/* Content Skeleton */}
        <div className="container-custom py-20 space-y-12">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {[1, 2, 3].map(i => (
              <div key={i} className="bg-white rounded-xl h-96 border border-gray-100 p-6 space-y-4">
                <div className="h-48 bg-gray-100 rounded-lg"></div>
                <div className="h-6 bg-gray-100 rounded w-3/4"></div>
                <div className="h-4 bg-gray-100 rounded w-1/2"></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="animate-pulse space-y-4">
      <div className="h-4 bg-gray-200 rounded w-3/4"></div>
      <div className="h-4 bg-gray-200 rounded w-1/2"></div>
    </div>
  );
};

export default SemanticSkeleton;
